import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {genderTypeAction} from "redux/actions";


export default function AddGenderType(status) {

    const [genderCode, setGenderCode] = useState('');
    const [description, setDescription] = useState('');


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        
    }, []);

    const addData = () =>{
        dispatch(genderTypeAction.add({ name: genderCode, desc: description}));
        setGenderCode('');
        setDescription('');
    } 

   
    return (
        <div>
            <h2>Add Gender Types</h2>
            <form action="/action_page.php">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="gender_code">Gender Code:</label>
                    <input type="text" className="form-control" id="gender_code" placeholder="Enter Gender Code" name="gender_code" onChange={e => setGenderCode(e.target.value)} value={genderCode}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="description">Description:</label>
                    <input type="text" className="form-control" id="description" placeholder="Enter Gender Description" name="description" onChange={e => setDescription(e.target.value)} value={description} />
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={addData}>Submit</button>
                </div>
            </form>
        </div>
    );
}
